import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";

import Container from "./Container";
import EffectChart from "./EffectChart";
import EffectFilter from "./EffectFilter";
import { useDispatch, useSelector } from "react-redux";
import { Dispatch, StoreState } from "../store";

const Effects: React.FC = () => {
  const dispatch = useDispatch<Dispatch>();
  const effectsFilter = useSelector((state: StoreState) => state.effectsFilter);
  const { effectsColumnsData } = useSelector(
    (state: StoreState) => state.effectsColumnsData
  );
  const { effectsData, loading } = useSelector(
    (state: StoreState) => state.effectsData
  );
  const [
    waitForColumnsFetchIfCustomerTypeChages,
    setWaitForColumnsFetchIfCustomerTypeChanges,
  ] = useState(false);
  const changeEffectFilter = (name: string, value: unknown) => {
    if (name === "customerType") {
      setWaitForColumnsFetchIfCustomerTypeChanges(true);
    }
    dispatch.effectsFilter.changeEffectsFilter({ [name]: value });
  };

  useEffect(() => {
    const fetchColumnRelatedData = async () => {
      await dispatch.effectsColumnsData.fetchColumnsData(
        effectsFilter.customerType
      );
      await dispatch.effectsFilter.fetchColumns(effectsFilter.customerType);
      setWaitForColumnsFetchIfCustomerTypeChanges(false);
    };
    fetchColumnRelatedData();
  }, [dispatch, effectsFilter.customerType]);

  useEffect(() => {
    if (!waitForColumnsFetchIfCustomerTypeChages) {
      dispatch.effectsData.fetchEffectsData({
        columnName: effectsFilter.columnName,
        customerType: effectsFilter.customerType,
      });
    }
  }, [dispatch, effectsFilter, waitForColumnsFetchIfCustomerTypeChages]);

  return (
    <Container>
      <Grid container={true} spacing={2}>
        <Grid item={true} xs={12}>
          <EffectFilter
            changeFilter={changeEffectFilter}
            effectsFilter={effectsFilter}
            effectsColumnsData={effectsColumnsData}
          />
        </Grid>
        <Grid item={true} xs={12}>
          <EffectChart effectsData={effectsData} loading={loading} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Effects;



// WEBPACK FOOTER //
// ./src/components/Effects.tsx